module.exports = __webpack_public_path__ + "img/ahosj-urpu4.c57197a2.png";